import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Load } from '../interfaces/load';
import { WeightUnit } from '../enums/WeightUnit';

@Injectable({
  providedIn: 'root',
})
export class LoadService {
  prefix = `${environment.serverUrl}/loads`;

  constructor(private http: HttpClient) {}

  async getLoads(): Promise<Load[]> {
    return await this.http.get<Load[]>(`${this.prefix}`).toPromise();
  }

  async getTemplateLoads(): Promise<Load[]> {
    return await this.http.get<Load[]>(`${this.prefix}/templates`).toPromise();
  }
  async searchTemplateLoads(query): Promise<Load[]> {
    return await this.http.get<Load[]>(`${this.prefix}/templates/search?query=${query}`).toPromise();
  }
  editLoad(load: Load) {
    return this.http.put(`${this.prefix}`, load).toPromise();
  }

  async deleteLoad(loadId: string[]): Promise<any> {
    // @ts-ignore
    return await this.http.delete(`${this.prefix}`, { body: loadId }).toPromise();
  }

  async addLoad(load: Load): Promise<Load> {
    return await this.http.post<Load>(`${this.prefix}`, load).toPromise();
  }

  async addTemplateLoad(load: Load): Promise<Load> {
    return await this.http.post<Load>(`${this.prefix}/templates`, load).toPromise();
  }

  async getLoadTypes(): Promise<string[]> {
    return await this.http.get<string[]>(`${this.prefix}/get-load-types`).toPromise();
  }

  async getVehicleRequirements(): Promise<string[]> {
    return await this.http.get<string[]>(`${this.prefix}/get-vehicle-requirements`).toPromise();
  }

  async getWeightUnits(): Promise<WeightUnit[]> {
    return await this.http.get<WeightUnit[]>(`${this.prefix}/get-weight-units`).toPromise();
  }

  async getMeasureUnits(): Promise<string[]> {
    return await this.http.get<string[]>(`${this.prefix}/get-measure-units`).toPromise();
  }
}
